export const VEGETATION_RISK_TYPES = {
    sign_sighting: "Sign Sighting Risk",
    signal_sighting: "Signal Sighting Risk",
    sign_within_1m: "Sign Within One Meter Risk",
    signal_within_1m: "Signal Within One Meter Risk",
    train_contact: "Train Contact Risk",
    next_to_ole: "Next to OLE Risk",
    overhanging: "Overhanging Risk",
};
